import { useState } from 'react';

import { DASHBOARDS_EVENT_TYPE } from '../screens/EventsDashboard/constants';

export const useLayoutManager = (charts, tables, pieCharts, countCharts, counters, barCharts) => {
  const [layoutChanges, setLayoutChanges] = useState({});

  const hasChanges = !!Object.values(layoutChanges)?.length;

  const checkLayoutChange = currentLayout => {
    const originalLayouts = {
      [DASHBOARDS_EVENT_TYPE.CHARTS]: Object.assign({}, ...charts.map(x => ({ [x.id]: x.layout }))),
      [DASHBOARDS_EVENT_TYPE.TABLES]: Object.assign({}, ...tables.map(x => ({ [x.id]: x.layout }))),
      [DASHBOARDS_EVENT_TYPE.PIE_CHARTS]: Object.assign(
        {},
        ...pieCharts.map(x => ({ [x.id]: x.layout })),
      ),
      [DASHBOARDS_EVENT_TYPE.COUNT_CHARTS]: Object.assign(
        {},
        ...countCharts.map(x => ({ [x.id]: x.layout })),
      ),
      [DASHBOARDS_EVENT_TYPE.COUNTER_CHARTS]: Object.assign(
        {},
        ...counters.map(x => ({ [x.id]: x.layout })),
      ),
      [DASHBOARDS_EVENT_TYPE.BAR_CHARTS]: Object.assign(
        {},
        ...barCharts.map(x => ({ [x.id]: x.layout })),
      ),
    };

    const newChanges = currentLayout.reduce((acc, { i: id, x, y, w, h }) => {
      const origin = Object.keys(originalLayouts).find(type => originalLayouts[type][id]);

      if (origin) {
        const {
          x: originalX,
          y: originalY,
          w: originalW,
          h: originalH,
        } = originalLayouts[origin][id];
        const layoutChanged =
          originalX !== x || originalY !== y || originalW !== w || originalH !== h;

        if (layoutChanged) {
          acc[id] = { x, y, w, h, id, origin };
        }
      }

      return acc;
    }, {});

    setLayoutChanges(newChanges);
  };

  return { layoutChanges, hasChanges, checkLayoutChange, setLayoutChanges };
};
